import React from "react"

const BlockNotFound = ({ type }) => (
  <div className="">Block "{type}" is not defined. Add it to _Blocks.js</div>
)

export default BlockNotFound
